/**
 * DataLayer component that renders markers and clustered markers. Properties to pass in Productconfig
 * required:
 * "type": "markerClusterOverlay"
 * "configType": "geojson"                                              // geojson or json
 * "url": "/data/overlays/marker-cluster-overlay-example-geojson.json", // url to geojson or json resource
 *
 * optional:
 * "gridSize": 100,                                                     // optional prop to control how bounds of clusters
 *                                                                      //expand while being generated (default: 60)
 * // Icon Obj for cluster and marker icons, css class overrides icon url
 * // default is icon from icon pn black shadow if nothing is spezified
 * "icons": {
 *  "cluster_icon_class": "livecam-cluster__icon icon-cluster-cam",
 *  "marker_icon_class": "icon-pin-cam",
 *  "cluster_icon_url": "http://ls2.wettercomassets.com/wcomv5/images/icon_pin_black_shadow_cluster.png",
 *  "marker_icon_url": "http://ls2.wettercomassets.com/wcomv5/images/icon_pin_black_shadow.png"
 * },
 * // in 'MarkerClusterLayer/utils' are min, max, average Function defined
 * you can pass in your Datalayer config a clusterFunction of those and a propertyKey of your geojson feature.property
 * "clusterFunction": "average",
 * "propertyKey": "temperature"
 *
 *
 * use this lib https://github.com/OpenGov/react-leaflet-cluster-layer
 */
import React from 'react';
import ClusterLayer from './ClusterLayer';
import Cluster from './Cluster';
import wrapDataLayer from '../Utils/Wrapper';
import {
  LayerGroup as LeafletLayerGroup
} from 'react-leaflet';

class MarkerClusterLayer extends React.PureComponent {
  /**
   * Returns a marker with or without a popup depending on properties.name
   * @param  {Object} feature Geojson Point feature, property key specified in productconfig/datalayer
   * @return {Object} Returns a marker
   */
  getMarkerFromGeoJson(feature, props) {
    return ({
      position: { lng: parseFloat(feature.geometry.coordinates[0]), lat: parseFloat(feature.geometry.coordinates[1]) },
      name: feature.properties.name || feature.properties.city || '',
      value: props.propertyKey ? feature.properties[props.propertyKey] : '',
      link: feature.properties.link || '',
      iconSize: props.iconSize || [],
      iconAnchor: props.iconAnchor || [],
      source: feature.properties.source || '',
    });
  }

  getMarkerFromJson(marker, props) {
    return ({
      position: { lng: marker.lon, lat: marker.lat },
      name: marker.name || marker.city,
      link: marker.link,
      value: marker.name || marker.city,
      iconSize: props.iconSize || [],
      iconAnchor: props.iconAnchor || [],
      source: marker.source || '',
    });
  }

  render() {
    const { config, icons, clusterFunction, leafletMap, configType, gridSize, precision, propertyKey, context } = this.props;
    // props to pass on to marker and cluster components
    const clusterProps = { icons, clusterFunction, precision, propertyKey, context };

    let markers = [];
    if (configType === 'geojson') {
      markers = config.features ? config.features.map(feat => this.getMarkerFromGeoJson(feat, this.props)) : [];
    } else {
      markers = config.items ? config.items.map(feat => this.getMarkerFromJson(feat, this.props)) : [];
    }

    return (
      <LeafletLayerGroup>
      {config && leafletMap != null ? <ClusterLayer
        markers={markers}
        clusterComponent={Cluster}
        map={leafletMap}
        gridSize={gridSize || 40}
        propsForClusters={clusterProps}
      /> : null}
      </LeafletLayerGroup>
    );
  }
}

export { MarkerClusterLayer as MarkerClusterLayerRaw };
export default wrapDataLayer(MarkerClusterLayer);



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/MarkerClusterLayer/index.js
 **/